import React from "react";
import { RiskCards } from "../../../ui";
import AssessmentCard from "./AssessmentCard/AssessmentCard";
const RiskCardsContainer = ({ riskAssessment, policyCountByRisk, }) => {
    return (React.createElement(RiskCards.Panel, null, React.createElement(RiskCards.CategoryList, { riskAssessment: riskAssessment, policyCountByRisk: policyCountByRisk, renderAssessmentCard: (props) => React.createElement(AssessmentCard, { ...props }) })));
};
export default RiskCardsContainer;
//# sourceMappingURL=RiskCards.js.map